document.addEventListener("DOMContentLoaded", function () {
  if ($('#find-garage-by-geoloc').length > 0 ||
      $('.row-header-home').length > 0 ||
      $('.page-about').length > 0

  ) {
    let $garagesList = $('div.garages-list');
    $('#map-detail-garage').html('<p class="m-l-1">' + translations.map_sentence_load + '</p>');
    $garagesList.html('<p class="sentence m-l-1">' + translations.garages_sentence_load + '</p>');

    // Cookiebot runs in auto-blocking mode, so before consent GTM never loads and
    // window.dataLayer is undefined - pushing to it threw a TypeError that killed the
    // whole place_changed handler, silently breaking search-by-city.
    window.dataLayer = window.dataLayer || [];

    // Tracked so a second search can cancel the first. Overlapping responses used to
    // race, and whichever arrived last won regardless of which was requested last.
    var garagesRequest = $.ajax({
      type: 'POST',
      url: translations.ajaxurl,
      data: {
        action: 'get_garages_html_map',
        lang: translations.lang,
        call: translations.call,
        contact: translations.contact,
        lat: translations.default_lat,
        lng: translations.default_lng
      },
      dataType: 'json'
    });

    garagesRequest.done(function (data) {
      $garagesList.find('p.m-l-1').remove();
      $garagesList.html(data.output);
      let locations = data.markers;

      let image = translations.theme_path + '/assets/img/marker.svg';

      let map = new google.maps.Map(document.getElementById('map-detail-garage'), {
        zoom: Number(translations.zoom_level),
        center: new google.maps.LatLng(translations.default_lat, translations.default_lng),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        styles: [
          {"featureType": "all","elementType": "geometry.fill","stylers": [{"color": "#e9e9e9"}]},
          {"featureType": "all","elementType": "geometry.stroke","stylers": [{"color": "#fafafa"}]},
          {"featureType": "administrative","elementType": "geometry.fill","stylers": [{"color": "#bbbbbb"}]},
          {"featureType": "administrative.country","elementType": "geometry","stylers": [{"color": "#ababab"}]},
          {"featureType": "administrative.country","elementType": "geometry.fill","stylers": [{"color": "#757575"}]},
          {"featureType": "administrative.land_parcel","elementType": "geometry.fill","stylers": [{"hue": "#35ff00"}]},
          {"featureType": "landscape.man_made","elementType": "geometry.fill","stylers": [{"color": "#f5f5f5"}]},
          {"featureType": "landscape.natural.landcover","elementType": "geometry","stylers": [{"hue": "#00ff3f"}]},
          {"featureType": "landscape.natural.landcover","elementType": "geometry.fill","stylers": [{"hue": "#00fff0"},{"lightness": "4"}]},
          {"featureType": "landscape.natural.terrain","elementType": "geometry.fill","stylers": [{"color": "#9b9b9b"}]},
          {"featureType": "poi.park","elementType": "geometry.fill","stylers": [{"color": "#c4c4c4"}]},
          {"featureType": "poi.park","elementType": "labels.text.fill","stylers": [{"color": "#a8a8a8"}]},
          {"featureType": "road.highway","elementType": "geometry.fill","stylers": [{"hue": "#ff6300"},{"saturation": "100"},{"lightness": "-41"}]},
          {"featureType": "road.highway","elementType": "geometry.stroke","stylers": [{"color": "#ffffff"}]},
          {"featureType": "road.highway","elementType": "labels.text","stylers": [{"hue": "#4100ff"}]},
          {"featureType": "road.highway","elementType": "labels.text.fill","stylers": [{"color": "#ffffff"}]},
          {"featureType": "road.arterial","elementType": "geometry.fill","stylers": [{"color": "#ffffff"}]},
          {"featureType": "road.arterial","elementType": "geometry.stroke","stylers": [{"color": "#fefefe"}]},
          {"featureType": "road.local","elementType": "geometry.stroke","stylers": [{"color": "#ffffff"}]},
          {"featureType": "water","elementType": "geometry","stylers": [{"hue": "#008eff"}]},
          {"featureType": "water","elementType": "geometry.fill","stylers": [{"color": "#1d3c90"}]}
        ]
      });

      var marker, i, markers = [], $cards = $(), cardNames = [];

      function clearMarkers() {
        // `markers = []` on its own only dropped the references: the Marker objects
        // stayed attached to the map's overlay layer with their click listeners still
        // registered, so every city search leaked a whole set of them.
        for (var m = 0; m < markers.length; m++) {
          google.maps.event.clearInstanceListeners(markers[m]);
          markers[m].setMap(null);
        }

        markers = [];
      }

      function setMarkers() {
        clearMarkers();

        // Cached once per rebuild. recenterMap() and the name filter used to run a
        // fresh jQuery selector for every card on every map event / keystroke.
        $cards = $garagesList.children('.garage-card');
        cardNames = [];

        for (i = 0; i < locations.length; i++) {
          cardNames.push(String(locations[i][0]).toLowerCase());

          marker = new google.maps.Marker({
            position: new google.maps.LatLng(locations[i][1], locations[i][2]),
            map: map,
            icon: image,

          });

          google.maps.event.addListener(marker, 'click', (function (marker, i) {
            return function () {
              infoWindow.setContent($garagesList.children().eq(i)[0].innerHTML);
              infoWindow.open(map, marker);
              $garagesList.scrollTop(0);
              $garagesList.animate({
                scrollTop: $garagesList.children().eq(i).offset().top - $garagesList.offset().top
              }, 500);

              map.setCenter(marker.getPosition());
            }
          })(marker, i));

          markers.push(marker);
        }
      }

      setMarkers();

      let infoWindow = new google.maps.InfoWindow();

      function toggleMarker(i) {
        google.maps.event.trigger(markers[i], "click");
        map.setCenter(markers[i].getPosition());
      }

      $(document).on('click', '.garage-card', function () {
        let index = $(this).index();

        toggleMarker(index);
      });

      if($('#city').length) {
        let input = document.getElementById('city'),
            options = {
              types: ['(regions)'],
              componentRestrictions: {country: translations.country}
            };

        let autocomplete = new google.maps.places.Autocomplete(input, options);

        google.maps.event.addListener(autocomplete, 'place_changed', function() {
          let place = autocomplete.getPlace(),
              lat = place.geometry.location.lat(),
              lng = place.geometry.location.lng(),
              placeName = place.name;

          window.dataLayer.push({
            event: 'garage_finder',
            city: placeName
          });

          if ($('.form-devis-1').length) {
            let placeId = place.place_id,
                placeName = place.formatted_address;

            document.getElementById("city").value = placeName;
            document.getElementById("place_name").value = placeName;
            document.getElementById("place_lat").value = lat;
            document.getElementById("place_lng").value = lng;
            document.getElementById("place_id").value = placeId;
          }

          let latLng = new google.maps.LatLng(lat, lng);
          reloadGaragesList(lat, lng);
          map.setCenter(latLng);
        });
      }

      if($('#garage_name').length) {
        // Debounced, and matched against the names already present in the AJAX payload.
        // This used to hide every card and then run a custom ':contains' pseudo-selector
        // on every keystroke - Sizzle cannot optimise a custom pseudo, so it walked every
        // node building a jQuery object and an uppercased string per <h2>, per keypress.
        // Interpolating the raw input into a selector also threw on a stray quote.
        let filterTimer = null;

        $('#garage_name').on("keyup", function () {
          let input = $(this).val().toLowerCase();

          if (filterTimer) {
            clearTimeout(filterTimer);
          }

          filterTimer = setTimeout(function () {
            filterTimer = null;

            if (input.length > 2) {
              for (let c = 0; c < cardNames.length; c++) {
                $cards.eq(c).css("display", cardNames[c].indexOf(input) >= 0 ? "block" : "none");
              }

              window.dataLayer.push({
                event: 'garage_finder',
                garage_finder: input
              });
            } else {
              $cards.css("display", "block");
            }
          }, 200);
        });
      }


      // 'idle' fires once, after panning/zooming settles. This was previously bound to
      // BOTH 'bounds_changed' and 'center_changed', which fire at roughly frame rate -
      // so recenterMap ran ~120x/second, and each run did one document query plus one
      // forced style write per marker. With a few hundred garages that saturated the
      // main thread for as long as the user kept dragging.
      map.addListener('idle', function () {
        recenterMap();
      });

      let recenterMap = function () {
        let bounds = map.getBounds();

        if (!bounds) {
          return;
        }

        for (let i = 0; i < markers.length; i++) {
          if (bounds.contains(markers[i].getPosition()) === true) {
            $cards.eq(i).show();
          } else {
            $cards.eq(i).hide();
          }
        }
      }

      let reloadGaragesList = function (lat, lng) {
        if (garagesRequest && garagesRequest.readyState !== 4) {
          garagesRequest.abort();
        }

        garagesRequest = $.ajax({
          type: 'POST',
          url: translations.ajaxurl,
          data: {
            action: 'get_garages_html_map',
            lang: translations.lang,
            call: translations.call,
            contact: translations.contact,
            lat: lat,
            lng: lng
          },
          dataType: 'json'
        });

        garagesRequest.done(function (data) {
          locations = data.markers;
          $garagesList.html(data.output);
          setMarkers();
        });
      }
    });
  }
});
